import { render, staticRenderFns } from "./products-form.vue?vue&type=template&id=2a1c2ff3"
import script from "./products-form.vue?vue&type=script&lang=js"
export * from "./products-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports